import { AcpUrl } from "app/modules/acp/constants";
import { NodUrl } from "app/modules/notice-of-death/constants";
import { LpaUrl } from "app/modules/lpa/constants";

export interface AllowAccessProps {
	children: JSX.Element;
	serviceType: ServiceType;
}

export enum ServiceType {
	ACP = "ACP",
	NOD = "NOD",
	LPA = "LPA",
}

export const listLandingPageUrl = {
	[ServiceType.ACP]: AcpUrl.landingPage,
	[ServiceType.NOD]: NodUrl.landingPage,
	[ServiceType.LPA]: LpaUrl.landingPage,
};

export const AllowAccessTitle = {
	[ServiceType.ACP]: "Do you allow access to your ACP information?",
	[ServiceType.NOD]: "Allow access to your information?",
	[ServiceType.LPA]: "Allow access to your information?",
};

export const ErrorTitle = {
	[ServiceType.ACP]: "Problem getting the status of your Advance Care Plan. Please try again.",
	[ServiceType.NOD]: "Problem getting the status of your Notice of Death. Please try again.",
	[ServiceType.LPA]: "Error granting access to OPG (Office of Public Guardian).",
};

export const ToastParams = {
	[ServiceType.ACP]: "acptoast=true",
	[ServiceType.NOD]: "nodtoast=true",
	[ServiceType.LPA]: "lpatoast=true",
};

export const listStartingPagesUrl = {
	[ServiceType.ACP]: AcpUrl.personalDetails,
	[ServiceType.NOD]: NodUrl.personalDetails,
	[ServiceType.LPA]: LpaUrl.personalDetails,
};
